import { selectors as current } from '../current';
import { selectors as session } from '../session';
import { mapStateToThis } from '../../components/new-product-intro/new-product-intro.utils';
import { ITEM_DEFINITION_CODES } from '../../constants';
import { SHOW_SPLASH_PAGE } from './';

export function getPromotions(state) {
  return state.promotions || {};
}

export function hasSeenSplashPage(state) {
  return (
    getPromotions(state).hasSeenSplashPage ||
    localStorage.getItem(SHOW_SPLASH_PAGE)
  );
}

export function initialState(state) {
  const { email, homePhone, cellPhone } = current.user(state);
  const move = current.move(state);

  const { eligiblePromotions, claimedPromotions } = getPromotions(state);

  return {
    eligiblePromotions,
    claimedPromotions,
    moveId: move.id(state),
    user: {
      email: email(state),
      phone: cellPhone(state) || homePhone(state),
    },
    sessionHeaders: {
      ...session.headers(state),
      app: 'mover',
    },
    status,
    nextStepCards: mapStateToThis(state, [ITEM_DEFINITION_CODES.PROMOTION]),
  };
}
